/**
 * 100vh problem with iOS Safari
 * @see https://dev.to/maciejtrzcinski/100vh-problem-with-ios-safari-3ge9
 */
export const setAppHeight = () => {
  document.documentElement?.style?.setProperty("--app-height", `${window.innerHeight}px`);
};
